/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretLeftRight = createReactComponent("caret-left-right", "IconCaretLeftRight", [
  ["path", { d: "M14 18l6 -6l-6 -6v12", key: "svg-0" }],
  ["path", { d: "M10 18l-6 -6l6 -6v12", key: "svg-1" }]
]);

export { IconCaretLeftRight as default };
//# sourceMappingURL=IconCaretLeftRight.js.map
